// extracted by mini-css-extract-plugin
export default {"logo":"CustomAppBar_logo__cQeMz","title":"CustomAppBar_title__KnEhU"};